define('components/course/models/slide-type/base',[
    'components/course/models/base'
], function (Base) {
    "use strict";

    return Base.extend({
        "authoringJSONKey": function () {
            return {
                "data": null
            };
        },

        "saveStateJSONKey": function () {
            return {};
        },

        "defaults": function () {
            return {
                "data": null,
                "radioChannel": null
            };
        },

        "initialize": function () {
            if (!this.get('data')) {
                this.set('data', this.defaults().data);
            }
        },

        // This method is overridden by the derived model
        // on a as-needed basis.
        "getTranscript": function () {}
    });
});

